export default __webpack_public_path__ + "static/me-2f57a794920abad68012e86e80af1905.jpg";